<glxy-form-field>
  <glxy-label>
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_START_TRIAL.PARTNER_START_TRIAL' | translate }}
  </glxy-label>
</glxy-form-field>
